import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "design-fields-and-sections",
  courseId: "forms",
  order: 2,
  title: "Design fields",
  subtitle: "And sections",
  summary:
    "Place and size fields on the PDF, name them so the AI knows what goes where, and group them into sections.",
  learn: [
    "Draw, move, and resize fields with snapping and alignment",
    "Set a field's type, name, and the context hint the AI reads",
    "Organize fields into sections",
  ],
  minutes: 5,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "The Form Designer is where you tell the AI what each box on the form means. A field with a clear name and a one-line hint fills correctly almost every time, and a field called \"Text 14\" does not.",
    },
    {
      type: "steps",
      items: [
        "Open a personal template and click **Edit Fields**.",
        "On a flat PDF, click **Auto-detect fields** to have the AI propose fields, then accept or reject each one in \"Review Suggested Fields\".",
        "Use Select to drag a new field or move one. Use Pan (or hold space) to move around the page.",
        "Turn on Snap to guides and use the align tools to line fields up.",
        "Click a field and set its properties: Field Name, Type (Text, Text Area, Checkbox, Circle), Multi-line, Section, Additional Context, Font Size, Line Spacing, Required.",
        "Choose \"+ New section...\" and assign fields to it (Subject, Vehicle, Narrative).",
        "Click **Save Template**.",
      ],
    },
    {
      type: "paragraph",
      text: "Sections keep the review screen readable when a form has dozens of fields.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Additional Context does the most work",
      text: "Write the hint the way you would brief a trainee: \"Vehicle plate as read from the registration, not the dispatch.\" The AI reads this when it fills the form.",
    },
    {
      type: "bullets",
      items: [
        "Shift-click or drag a marquee to select several fields and move or delete them together.",
        "Undo and redo work across every change in the designer.",
        "Circle fields have \"Circle one\" and \"Circle all that apply\" modes, for forms where the options are printed on the page.",
      ],
    },
    {
      type: "paragraph",
      text: "When the template is saved, \"Fill from audio\" is the next step.",
    },
  ],
  related: ["upload-a-form-template", "fill-a-form-from-audio", "form-outputs"],
};

export default lesson;
